// 其他監控來源：接第三方監控平台 API（Thingnario / SolarEdge / SmartPVMS ...）
// 目前只有一頁，來源之間用頁內 tab 切換
export const projectOtherSourcesRoutes = [
  {
    path: 'othersources',
    name: 'othersources',
    component: () => import('@/views/OtherSources.vue'),
    meta: {
      release: true,
      zhTw: '其他監控來源',
      icon: 'fas fa-plug',
      showMenu: true
    }
  }
]
